import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NotificationService } from './shared/ui/notification/notification.service';
import { NotificationComponent } from './shared/ui/notification/notification.component';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterModule, NotificationComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
})
export class AppComponent {
    public notificationService = inject(NotificationService);
}
